/**
 * Verify step — final summary and verification of the import.
 */
import { useTranslation } from "@/i18n";
import { Link } from "react-router";
import type { WizardState } from "../wizard-shell";

interface VerifyStepProps {
  state: WizardState;
}

export function VerifyStep(_props: VerifyStepProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 text-center py-8">
      <div className="text-4xl">🎉</div>
      <h2 className="text-2xl font-bold text-foreground">{t("migration.verify.title")}</h2>
      <p className="text-muted-foreground">{t("migration.verify.description")}</p>

      <div className="mx-auto max-w-md space-y-3">
        <Link
          to="/crm/contacts"
          className="block rounded-md border border-border px-4 py-3 text-sm font-medium text-foreground hover:bg-accent"
        >
          {t("migration.verify.viewContacts")}
        </Link>
        <Link
          to="/settings/migration/history"
          className="block rounded-md border border-border px-4 py-3 text-sm font-medium text-foreground hover:bg-accent"
        >
          {t("migration.verify.viewHistory")}
        </Link>
        <Link
          to="/settings/migration"
          className="block text-sm text-primary hover:underline"
        >
          {t("migration.verify.startAnother")}
        </Link>
      </div>
    </div>
  );
}
